import { TFunction } from 'i18next'
import * as yup from 'yup'

export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/

export const passwordValidation = (t: TFunction) =>
    yup
        .string()
        .required(t('user.error.password_required'))
        .min(8)
        .matches(PASSWORD_REGEX, t('user.error.password_complexity_not_meet'))

export default PASSWORD_REGEX
